import React from 'react'
import { BrandRoot, BrandWordmark } from './BrandMark.styles'

/**
 * The Orbit brand glyph plus the orange wordmark. Wrap in a link if it should
 * navigate; it carries no interaction of its own.
 */
const BrandMark: React.FC<{ className?: string }> = ({ className }) => (
	<BrandRoot className={className}>
		<img src="/orbit-icon.svg" alt="" width={26} height={26} />
		<BrandWordmark>Orbit</BrandWordmark>
	</BrandRoot>
)

export default BrandMark
